// components
import { styled, Box, BoxProps } from '@mui/material';

export const StyledZenPortalContainerBox = styled(Box)<BoxProps>(
  ({ theme }) => ({
    position: 'fixed',
    inset: 0,
    pointerEvents: 'none',
    zIndex: theme.zIndex.modal
  })
);

export const StyledHotZoneBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hotzoneWidth'
})<BoxProps & { hotzoneWidth?: number }>(({ hotzoneWidth = 16 }) => ({
  position: 'fixed',
  top: 24,
  right: 0,
  width: hotzoneWidth,
  height: '100vh',
  pointerEvents: 'auto'
}));

export const StyledFloatingToolbarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'open'
})<BoxProps & { open?: boolean; anchor: { top: number; right: number } }>(
  ({ open, anchor }) => ({
    position: 'fixed',
    top: anchor.top - 16, // undo the +16 we added
    right: anchor.right - 16,
    pointerEvents: 'auto',
    transform: open ? 'translateX(0)' : `translateX(calc(100% + 16px))`,
    transition: 'transform 220ms ease'
  })
);
